// mode épinglé de la barre d'actions de galaxie, persisté en localStorage + posé en attribut sur <html>

export type ToolbarPinMode = "pinned" | "unpinned";

const TOOLBAR_PIN_KEY = "system-toolbar-pin-mode";

export function getToolbarPinMode(): ToolbarPinMode {
  try {
    // localStorage peut être indisponible (navigation privée, etc.)
    return localStorage.getItem(TOOLBAR_PIN_KEY) === "pinned" ? "pinned" : "unpinned";
  } catch {
    return "unpinned";
  }
}

export function setToolbarPinMode(mode: ToolbarPinMode) {
  try {
    localStorage.setItem(TOOLBAR_PIN_KEY, mode);
  } catch {
    // préférence non persistée, on applique quand même le mode pour la session
  }
  applyToolbarPinMode(mode);
}

/** Pose l'attribut lu par theme-system.css, sans toucher à la valeur stockée. */
export function applyToolbarPinMode(mode: ToolbarPinMode) {
  document.documentElement.setAttribute("data-system-toolbar-pin", mode);
}
